/** @jsxImportSource @emotion/react */
import React, { Component, useState } from 'react'
import { jsx, css } from '@emotion/react'
import { default_theme as theme } from '../../emotion/theme'

export const OrangeLinkButton = ({ onClick, children, ...props }) => {

    return (
        <div css={style} onClick={onClick}>
          {children}
        </div>
    )

}

const style = css`
cursor: pointer;
padding-left: 0px;
color: ${theme.colors.secondary_orange};

&:hover {
text-decoration: underline;
}
`
